import React, { useCallback, useMemo, useState } from 'react';

import { Chip, MenuItem } from '@mui/material';

import { HistoryOfChangesItem } from 'pages/Bulletin/types/history-of-changes';
import formatDate from 'utils/format-date';

import EyeIcon from './assets/eye.svg';
import useStyles from './styles';

interface Props {
    item: HistoryOfChangesItem;
    current?: boolean;
    selected?: boolean;
    onSelect?: (version: number) => void;
    className?: string;
}

const VersionMenuItem: React.FC<Props> = ({ item, selected, current, onSelect, className }) => {
    const { classes } = useStyles();
    const { version, published, changes } = item;
    const [isHovered, setIsHovered] = useState(false);

    const onMouseEnter = useCallback(() => setIsHovered(true), []);
    const onMouseLeave = useCallback(() => setIsHovered(false), []);
    const updated = useMemo(() => Object.keys(changes).join(', '), [changes]);

    const handleSelect = useCallback(() => onSelect?.(version), [onSelect, version]);

    return (
        <MenuItem
            key={item.version}
            onClick={handleSelect}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            classes={{ root: classes.root, selected: classes.selected }}
            className={className}
            disableRipple
            selected={selected}
        >
            <div className={classes.data}>
                <div className={classes.container}>
                    <span className={classes.version}>{`Version ${version}`}</span>
                    {current ? (
                        <Chip label={'Current'} className={classes.current} variant="outlined" size="small" />
                    ) : null}
                </div>
                <span className={classes.updated}>{`Updated fields: ${updated}`}</span>
            </div>
            {isHovered ? (
                <div className={classes.preview}>
                    <EyeIcon />
                    {'Preview'}
                </div>
            ) : (
                <div className={classes.datetime}>
                    <span className={classes.date}>{formatDate(published, 'LLL dd, yyyy')}</span>
                    <span className={classes.time}>{formatDate(published, 'h:mm aaaa')}</span>
                </div>
            )}
        </MenuItem>
    );
};

export default VersionMenuItem;
